export const ACTIONS = <const>{
	RESET: 'RESET',
	UPDATE: 'UPDATE',

	SET_LOADING: 'SET_LOADING',
	SET_SAVING: 'SET_SAVING',
	SET_TEMPLATE_ID: 'SET_TEMPLATE_ID',

	ADD_PERMISSION: 'ADD_PERMISION',
	DELETE_PERMISSION: 'DELETE_PERMISSION',
	UPDATE_PERMISSION: 'UPDATE_PERMISSION',
};
